import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Tab from './Tab';

import styles from './TabsLegacy.module.scss';

const cx = classNames.bind(styles);

class TabsLegacy extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        render: PropTypes.func
      })
    ),
    className: PropTypes.string,
    variant: PropTypes.string,
    activeIndex: PropTypes.number
  };

  static defaultProps = {
    items: [],
    onChange: () => {},
    className: '',
    variant: 'underlined',
    activeIndex: 0
  };

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: props.activeIndex ?? 0
    };
  }

  handleClick = index => {
    this.setState({
      activeIndex: index
    });
  };

  render() {
    const { className, variant } = this.props;
    const tabsClassName = cx(styles.root, className);
    const tabs = this.props.items.map((tab, index) => {
      return (
        <Tab
          content={tab.label}
          id={index}
          onClick={this.handleClick}
          key={tab.id || index}
          active={this.state.activeIndex === index}
          onChange={this.props.onChange}
          variant={variant}
        />
      );
    });

    const activeTab = this.props.items[this.state.activeIndex];
    return (
      <div className={tabsClassName}>
        <div className={styles.items}>{tabs}</div>
        <div className={styles.content}>{activeTab.render()}</div>
      </div>
    );
  }
}

export default TabsLegacy;
